import Translations from '@helpers/translations'
import { returnsClickEvent } from '@components/returns/helpers'
import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'
import { SetProductToReturn } from '../ProductCardFooter'
import { checkStoreIs } from '@helpers/env'

type ProductCardButtonsProps = {
  id: string
  expired: boolean
  isMTO: boolean
  setProductToReturn: SetProductToReturn
}

const ProductCardButtons = ({
  id,
  setProductToReturn,
  expired,
  isMTO
}: ProductCardButtonsProps) => {
  const setProductToExchange = () => {
    returnsClickEvent({
      label: 'Exchange'
    })
    setProductToReturn(id, 'exchange')
  }
  const setProductToRefund = () => {
    returnsClickEvent({
      label: 'Refund'
    })
    setProductToReturn(id, 'refund')
  }

  return (
    <div className={styles.buttons}>
      <Button
        disabled={expired}
        onClick={setProductToRefund}
        variant="primary_outline"
        fullWidth="always"
        size="small"
      >
        {Translations.localise('pages.returns.refund')}
      </Button>
      {!checkStoreIs('us') && !isMTO && (
        <Button
          disabled={expired}
          onClick={setProductToExchange}
          variant="primary"
          fullWidth="always"
          size="small"
        >
          {Translations.localise('pages.returns.exchange')}
        </Button>
      )}
    </div>
  )
}

export default ProductCardButtons
